import { useEffect, useMemo, useState } from "react";
import { calculateBmi, convertImperialHeightMode, convertImperialWeightMode, convertUnitSystem, syncMeasurementFields } from "../logic/bmi";
import { loadBmiState, saveBmiState } from "../logic/storage";
import type { BmiCalculatorState, BmiImperialHeightMode, BmiImperialWeightMode, BmiUnitSystem } from "../types";

export function useBmiCalculator() {
  const [state, setState] = useState<BmiCalculatorState>(loadBmiState);
  const result = useMemo(() => calculateBmi(state), [state]);

  useEffect(() => {
    saveBmiState(state);
  }, [state]);

  function updateUnitSystem(unitSystem: BmiUnitSystem) {
    setState((current) => convertUnitSystem(current, unitSystem));
  }

  function updateImperialHeightMode(imperialHeightMode: BmiImperialHeightMode) {
    setState((current) => convertImperialHeightMode(current, imperialHeightMode));
  }

  function updateImperialWeightMode(imperialWeightMode: BmiImperialWeightMode) {
    setState((current) => convertImperialWeightMode(current, imperialWeightMode));
  }

  function updateField(field: keyof BmiCalculatorState, value: string) {
    setState((current) => syncMeasurementFields({ ...current, [field]: value }, field));
  }

  return {
    result,
    state,
    updateField,
    updateImperialHeightMode,
    updateImperialWeightMode,
    updateUnitSystem
  };
}
